import { nanoid } from 'nanoid';
import { useQueryState } from 'nuqs';

import { type WorkflowOwner } from '@/tsClient/servers/noodleApi/ApiDefinition/workflows';
import type * as ApiModels from '@/typings/api-models';

import { type QueryStateSchema, queryParam, queryStateParser } from './queryStateParser';

const QS_TYPE: QueryStateSchema['type'] = 'initiateCase';

export const useOpenInitiateCasePane = (): ((args?: {
  associatedUserWorkflowId?: string;
  owners?: WorkflowOwner[];
  customer?: Pick<ApiModels.Person, 'id' | 'name' | 'email'>;
}) => void) => {
  const [__, setState] = useQueryState(queryParam, queryStateParser);

  return (args): void => {
    setState((prevState) => [
      ...(prevState || []),
      {
        associatedUserWorkflowId: args?.associatedUserWorkflowId,
        customer: args?.customer,
        id: 'initiateCase',
        key: nanoid(),
        owners: args?.owners,
        type: QS_TYPE,
      },
    ]);
  };
};
